// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"225":"7f23ffb7","537":"e0ca7f20","614":"c6298ef2"}[chunkId] + ".chunk.css";
};